/* KYMCO Parts - "Often needed for the same job" (batch 7-7).
   Renders the catalogue's own same-assembly list client-side from
   GET https://catalog.kymcopartsstore.com/api/assembly/<number lower-cased>
   (7-7a report section 11). The list is priced and changes with the
   catalogue, which is exactly why it is not baked into the description.
   The endpoint ships with batch 7-7a; until then it 404s and this module
   renders nothing at all. Any error, 404 or empty list is silent. */
(function () {
  var host = document.querySelector('[data-kymco-assembly]');
  if (!host) return;
  var number = (host.getAttribute('data-part-number') || '').toLowerCase();
  if (!number) return;

  function card(part) {
    var a = document.createElement('a');
    a.className = 'kx-assembly__card';
    a.href = part.url;
    if (part.image) {
      var img = document.createElement('img');
      img.src = part.image;
      img.loading = 'lazy';
      img.alt = 'KYMCO ' + part.name + ' ' + part.number;
      a.appendChild(img);
    }
    var name = document.createElement('span');
    name.className = 'kx-assembly__name';
    name.textContent = part.name;
    var num = document.createElement('span');
    num.className = 'kx-assembly__number';
    num.textContent = part.number;
    a.appendChild(name);
    a.appendChild(num);
    if (typeof part.price === 'number') {
      var price = document.createElement('span');
      price.className = 'kx-assembly__price';
      price.textContent = '$' + part.price.toFixed(2);
      a.appendChild(price);
    }
    return a;
  }

  function render(data) {
    if (!data || !data.parts || !data.parts.length) return;
    var list = document.createElement('div');
    list.className = 'kx-assembly__list';
    data.parts.forEach(function (part) {
      if (part && part.url && part.number) list.appendChild(card(part));
    });
    if (!list.childNodes.length) return;
    host.appendChild(list);
    host.hidden = false;
  }

  function start() {
    fetch('https://catalog.kymcopartsstore.com/api/assembly/' + encodeURIComponent(number))
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(render)
      .catch(function () {
        console.debug('kymco-assembly: nothing to show for ' + number);
      });
  }

  if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 3000 });
  else window.addEventListener('load', start);
})();
